// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__tqFIN","horizontal":"Divider_horizontal__U5BDp","vertical":"Divider_vertical__7YNjO"};